export default __webpack_public_path__ + "static/media/icon_ui_application.d57dded7.png";